module.exports = __webpack_public_path__ + "components/rewards/freefloski/static/logo-6127f2a26df169e378fa368cf01ded85.jpg";